import { render, staticRenderFns } from "./MarkdownContent.vue?vue&type=template&id=f2ffac58&scoped=true"
import script from "./MarkdownContent.vue?vue&type=script&lang=js"
export * from "./MarkdownContent.vue?vue&type=script&lang=js"
import style0 from "./MarkdownContent.vue?vue&type=style&index=0&id=f2ffac58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ffac58",
  null
  
)

export default component.exports